export default [
  {
    path: '/records/',
    name: 'Records',
    component: () => import('../components/Records.vue'),
    meta: {
      authenticate: true,
    },
  },
  {
    path: '/subscriberdashboard/',
    name: 'SubcriberDashboard',
    component: () => import('../components/subscriber/SubscriberDashboard.vue'),
  },
  {
    path: '/formquestiondashboard/',
    name: 'FormQuestionDashboard',
    component: () =>
      import('../components/superuser/FormQuestionDashboard.vue'),
  },
  {
    path: '/dashboard/',
    name: 'Dashboard',
    component: () => import('../components/Dashboard.vue'),
    meta: {
      authenticate: true,
    },
  },
];
